import React, { useState, useEffect } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';

const AuthPage: React.FC = () => {
  useEffect(() => {
    document.title = 'כניסת מנהל - חיים פלוס';
  }, []);
  const { signInWithGoogle, signOut, user } = useAuth();
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');
  const navigate = useNavigate();
  const location = useLocation();
  const from = (location.state && location.state.from) || '/admin';

  // List of allowed email addresses
  const allowedEmails = [
    'yanivy@gmail.com',
    'osnatrmc@gmail.com',
    'chenmor69@gmail.com',
    'eladuxd@gmail.com',
    'nir0201@gmail.com',
  ];

  const handleGoogleSignIn = async () => {
    setLoading(true);
    setError('');
    try {
      const signedInUser = await signInWithGoogle();
      // if (signedInUser && allowedEmails.includes(signedInUser.email || '')) {
      if (signedInUser) {
        navigate(from, { replace: true });
      } else {
        setError('כתובת האימייל שלך אינה מורשית לגישה.');
        signOut();
      }
    } catch (e) {
      console.error(e);
      setError('שגיאה בהתחברות ב-Google');
    } finally {
      setLoading(false);
    }
  };
  return (
    <div className="admin-login-container">
      <a href="#main-content" className="skip-link">דלג לתוכן הראשי</a>
      <main id="main-content" className="admin-login-card">
        <div className="admin-logo">
          <img src="/assets/life-logo.svg" alt="חיים פלוס" style={{ height: '60px', marginBottom: '16px' }} />
        </div>
        <h1 className="admin-login-title">כניסת מנהל</h1>
        <p className="admin-login-subtitle">התחבר עם חשבון Google שלך</p>

            {user && !error ? (
          <div className="admin-login-form">
            <div className="admin-success-message" role="status" aria-live="polite">
              ברוך הבא, {user.displayName || user.email}
            </div>
            <button
              className="admin-login-btn"
              onClick={() => navigate('/admin')}
            >
              לצפייה בעמוד הניהול
            </button>
          </div>
        ) : (
          <div className="admin-login-form">

            {error && (
              <div className="admin-error-message" role="alert" aria-live="assertive">{error}</div>
            )}
            <button
              className="admin-login-btn"
              onClick={handleGoogleSignIn}
              disabled={loading}
              aria-busy={loading}
              aria-disabled={loading}
            >
              {loading ? (
                <div className="admin-loading" aria-busy="true">
                  <div className="admin-loading-spinner" aria-hidden="true"></div>
                  מתחבר...
                </div>
              ) : (
                'התחבר עם Google'
              )}
            </button>
          </div>
        )}
      </main>
    </div>
  );
};

export default AuthPage;